import { ACTIVE, HIDDEN } from '../../classnames/design-system';
import { SELECTORS } from './constants';

export class Tab {
  constructor(container) {
    this.container = container;
  }

  handleClick = ({ currentTarget: { dataset: { groupId }}}) => {
    this.container.querySelectorAll(`.${SELECTORS.TAB_CONTENT}`).forEach((content) => {
      content.classList.toggle(ACTIVE, content.dataset.groupId === groupId);
      content.classList.toggle(HIDDEN, content.dataset.groupId !== groupId);
    });

    this.container.querySelectorAll(`.${SELECTORS.TAB}`).forEach((groupName) => {
      groupName.classList.toggle(ACTIVE, groupName.dataset.groupId === groupId);
    });
  };

  initializeEventListeners = () => {
    const items = this.container.querySelectorAll(`.${SELECTORS.TAB}`);

    items.forEach((item) => {
      item.addEventListener('click', this.handleClick);
    });
  };
}
